export function mapValueWithinRange(value: number, fromMin: number, fromMax: number, toMin: number, toMax: number) {
  // Ensure the value is within the source range
  const clampedValue = Math.min(Math.max(value, fromMin), fromMax);
  // Calculate the percentage of the value within the source range
  const percentage = (clampedValue - fromMin) / (fromMax - fromMin);
  // Map the percentage to the target range
  const mappedValue = toMin + percentage * (toMax - toMin);
  return mappedValue;
}
